import { useState, useEffect } from 'react'

export const usePasswordValidation = ({
    firstPassword = '',
    secondPassword = '',
    minRequiredLength = 6,
    maxRequiredLength = 16,
    numberValidation = true,
    letterValidation = true,
    lengthValidation = true,
}) => {
    const [validLength, setValidLength] = useState(null)
    const [hasNumber, setHasNumber] = useState(null)
    const [hasLetter, setHasLetter] = useState(null)
    const [match, setMatch] = useState(null)

    useEffect(() => {
        lengthValidation &&
            setValidLength(
                (firstPassword.length >= minRequiredLength && firstPassword.length <= maxRequiredLength)
                    ? true
                    : false
            )
            letterValidation && setHasLetter(/[a-z]/.test(firstPassword))
            numberValidation && setHasNumber(/\d/.test(firstPassword))
            setMatch(firstPassword && firstPassword === secondPassword)
    }, [
        firstPassword,
        secondPassword,
        minRequiredLength,
        maxRequiredLength,
        lengthValidation,
        numberValidation,
        letterValidation
    ])

    return [validLength, hasNumber, match, hasLetter]
}
